/* eslint-disable @typescript-eslint/ban-types */
import { useForm, UseFormOptions } from "react-hook-form";

export const useOnChangeFormHook = <T extends object>(
  values?: UseFormOptions<T>
) =>
  useForm<T>({
    mode: "onChange",
    ...values,
  });

export const useOnSubmitFormHook = <T extends object>(
  values?: UseFormOptions<T>
) =>
  useForm<T>({
    mode: "onSubmit",
    ...values,
  });
